/**
 * 商管端通用路由
 */
export default [
  {
    path: '/manageHome',
    component: () => import(/* webpackChunkName: "Main" */ '@/views/manageHome.vue'),
    meta: { requiresAuth: true, title: '首页', icon: 'el-icon-s-home', role: true },
  },
  {
    path: '/app',
    component: () => import(/* webpackChunkName: "Main" */ '@/views/Main.vue'),
    meta: { requiresAuth: true, title: '我的应用', icon: 'el-icon-menu' },
    children:
      [
        // {
        //   path: 'to/:id',
        //   component: () => import(/* webpackChunkName: "Main" */ '@/views/AppRedirect.vue'),
        // },
        // {
        //   path: ':activityId/:id',
        //   component: () => import(/* webpackChunkName: "Main" */ '@/views/App.vue'),
        // },
        // {
        //   path: ':id',
        //   component: () => import(/* webpackChunkName: "Main" */ '@/views/App.vue'),
        // },
      ],
  },
  {
    path: '*',
    component: () => import(/* webpackChunkName: "Main" */ '@/views/Main.vue'),
    meta: { title: '404 Page Not Found' },
    children:
      [
        {
          path: '',
          component: () => import(/* webpackChunkName: "Main" */ '@/components/base/404.vue'),
        },
      ],
  },
];
